import { ApolloError, useQuery } from '@apollo/client';
import {
  GET_LATE_ADD_TO_CART_USER_ELIGIBILITY,
  LateAddToCartUserEligibilityQueryResult,
} from '../queries/userEligibility';

export type UseLateAddToCartUserEligibilityResult = {
  isEligible: boolean;
  loading: boolean;
  error?: ApolloError;
};

export const useLateAddToCartUserEligibility =
  (): UseLateAddToCartUserEligibilityResult => {
    const { data, loading, error } =
      useQuery<LateAddToCartUserEligibilityQueryResult>(
        GET_LATE_ADD_TO_CART_USER_ELIGIBILITY,
        { fetchPolicy: 'network-only' },
      );

    return {
      isEligible: data?.getLateAddToCartUserEligibility.isEligible ?? false,
      loading,
      error,
    };
  };
